/**
 * Created by mac on 7/28/25
 */

// eslint-disable-next-line
var OrdersAlgoHelper = {};
const MINUTES_PER_ENERGY = 2;

OrdersAlgoHelper.RecOutput = function (algorithm, N) {
    const orders = [];

    const fieldGenerators = Field.filter((unit) => Families[unit.code].type === "generator");
    const generatorsMap = OrdersAlgoHelper.mergeUnitsValues(fieldGenerators);

    const sumProgress = locationData.stagesProgress.reduce((acc, num) => {
        acc.push((acc.length ? acc[acc.length - 1] : 0) + num);
        return acc;
    }, []);
    let stars = 0;
    let currentFix = 0;

    const cupGenerators = {};

    for (let i = 0; i < N; i++) {
        const order = algorithm.next();
        algorithm.dataSource.orderManager.index++;
        const previous = orders[i - 1];
        if (previous) {
            previous.forEach((order) => {
                stars += Merge2CustomerRecipe._getStarsBonuses({ code: order.line, stage: order.stage });
            });

            if (stars >= sumProgress[currentFix]) {
                const rewards = locationData.rewardsForFixes[currentFix];

                if (rewards) {
                    rewards.forEach((reward) => {
                        if (reward.unit && ["bb", "aa"].includes(reward.unit.code)) {
                            const config = CupsConfig[reward.unit.code][`stage${reward.unit.stage}`];
                            const rewards = CupsConfig.parseRewards(config.rewards);
                            const prob = config.probabilities;
                            rewards.forEach((unit, index) => {
                                if (Families[unit.code].type === "generator") {
                                    cupGenerators[unit.code] = cupGenerators[unit.code] || 0;
                                    cupGenerators[unit.code] += prob[index];
                                    if (cupGenerators[unit.code] >= 1) {
                                        OrdersAlgoHelper.mergeUnitsValues([unit], generatorsMap);
                                        cupGenerators[unit.code] -= 1;
                                    }
                                }
                            });
                        }

                        if (reward.unit && Families[reward.unit.code].type === "generator") {
                            OrdersAlgoHelper.mergeUnitsValues([reward.unit], generatorsMap);
                        }

                        for (const code in generatorsMap) {
                            const stage = Math.min(Math.floor(Math.log2(generatorsMap[code])), Families[code].units.length - 1);
                            cleverapps.unitsLibrary.openUnit({ code, stage });
                        }
                    });
                }
                currentFix++;
            }
        }
        
        if (order === undefined) {
            break;
        }
        orders.push(order);
    }
    return orders;
};

OrdersAlgoHelper.GeneratorStageIndex = function (generator) {
    const location = cleverapps.meta.getSelectedLocation();

    let generatorStage = Merge2.current.getAvailableGeneratorStage(generator.code, location.stars.isEnoughStars());

    if (generatorStage === undefined) {
        return;
    }

    if (generator.code === "AB") {
        generatorStage = Math.max(generatorStage, 3);
    }

    return generatorStage;
};

OrdersAlgoHelper.GeneratorStage = function (generator) {
    const generatorStage = OrdersAlgoHelper.GeneratorStageIndex(generator);

    if (generatorStage === undefined) {
        return;
    }

    return OrdersAlgoConfig.generators[generator.code].stages[generatorStage];
};

OrdersAlgoHelper.GeneratorForItem = function (item, generators) {
    let res = undefined;

    generators.forEach((generator) => {
        const generatorStage = OrdersAlgoHelper.GeneratorStage(generator);
        const generatorConfig = OrdersAlgoConfig.generators[generator.code];

        let drop = generatorStage && generatorStage.drop;
        if (drop && generatorConfig.algorithm && generatorConfig.algorithm.overrideDrop) {
            drop = generatorConfig.algorithm.overrideDrop;
        }

        if (drop && drop.includes(item)) {
            res = { code: generator.code, stage: OrdersAlgoHelper.GeneratorStageIndex(generator) };
        }
    });

    return res;
};

OrdersAlgoHelper.WeightForLine = function (line, generator) {
    const generatorStage = OrdersAlgoHelper.GeneratorStage(generator);

    return generatorStage.weights ? generatorStage.weights[generatorStage.drop.indexOf(line)] : 1;
};

OrdersAlgoHelper.MinutesPerItem = function (item, stage, generator) {
    const generatorStage = OrdersAlgoHelper.GeneratorStage(generator);

    const weight = generatorStage.weights ? generatorStage.weights[generatorStage.drop.indexOf(item)] : 1;

    const cooldown = (generatorStage.cooldown || OrdersAlgoConfig.generators[generator.code].cooldown) / (generatorStage.spawn || OrdersAlgoConfig.generators[generator.code].spawn) || 0;

    const power = ((generatorStage.power || 100) - 100) / 100;
    const powerMin = Math.floor(power);
    const powerMax = powerMin + 1;
    const p2 = power - powerMin;
    const p1 = 1 - p2;

    const customPrice = OrdersAlgoConfig.generators[generator.code].algorithm && OrdersAlgoConfig.generators[generator.code].algorithm.customPrice;
    const energy = (1 << stage) / (p1 * (1 << powerMin) + p2 * (1 << powerMax)) * (customPrice || 1) / weight;
    return Math.max(energy * cooldown, energy * MINUTES_PER_ENERGY);
};

OrdersAlgoHelper.getGeneratorCodeForLine = function (line) {
    const codes = Object.keys(OrdersAlgoConfig.generators);
    for (let i = 0; i < codes.length; ++i) {
        let isSuitable = false;
        OrdersAlgoConfig.generators[codes[i]].stages.forEach((stage) => {
            if (stage.drop && stage.drop.includes(line)) {
                isSuitable = true;
            }
        });

        if (isSuitable) {
            return codes[i];
        }
    }
};

OrdersAlgoHelper.StageRange = function (line) {
    const minStage = 2;
    const lastOpenStage = Math.max(minStage, cleverapps.unitsLibrary.getLastOpenStage(line) || 0);
    const maxStage = Math.min(OrdersAlgoConfig.lines[line] - 1, lastOpenStage + 1);
    return { minStage, maxStage };
};

OrdersAlgoHelper.mergeUnitsValues = function (units, result) {
    result = result || {};

    units.forEach((unit) => {
        const stage = unit.stage;

        const value = 2 ** stage;

        if (!result[unit.code]) {
            result[unit.code] = 0;
        }

        result[unit.code] += value;
    });

    return result;
};

OrdersAlgoHelper.DefaultGenerators = function () {
    return [
        { code: "AB", stage: 6 },
        { code: "CD", stage: 5 },
        { code: "E", stage: 4 },
        { code: "F", stage: 5 },
        { code: "GH", stage: 5 },
        { code: "I", stage: 4 }
    ];
};
